import axios from 'axios'

// Get all show dates for business
const getAllForBusiness = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/bordero/business/${iniDate}/${endDate}`)
  return data
}

// Get all show dates for business
const getAllForProducer = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/bordero/producer/${iniDate}/${endDate}`)
  return data
}

// Get all show dates for business
const getForBusiness = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/bordero/business/${showDate}`)
  return data
}

// Get all show dates for business
const getForProducer = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/bordero/producer/${showDate}`)
  return data
}

export {
  getAllForBusiness,
  getAllForProducer,
  getForBusiness,
  getForProducer
}
